module.exports = __webpack_public_path__ + "img/info.5bd26cab.svg";